import { inject, Injectable } from '@angular/core';
import { SetupHandler } from './setup.handler';
import { CONFIG_PLAUSIBLE } from '@aipb/util/di';

@Injectable({
  providedIn: 'root'
})
export class PlausibleHandler extends SetupHandler {
  private plausible = inject(CONFIG_PLAUSIBLE);
  constructor() {
    super('📈 plausible.handler');
  }

  handle() {
    if (!this.plausible) return;

    const script = document.createElement('script');
    script.src = this.plausible.src;
    script.setAttribute('data-domain', this.plausible.domains.join(','));
    document.head.appendChild(script);

    this.addLogMessage(
      `added plausible script with src [${this.plausible.src}] for domains [${this.plausible.domains.join(',')}]`
    );
  }
}
